module.exports = __webpack_public_path__ + "img/footer03.78ce3943.png";